import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, Clock, ArrowRight } from 'lucide-react';

const blogPosts = [
  {
    id: 'sleep-apnea-dentist-el-dorado-hills-ca',
    title: 'Sleep Apnea Dentist in El Dorado Hills, CA: Finally Sleep Like You Did in Your 30s',
    excerpt: "El Dorado Hills, let's talk about that exhaustion you've been blaming on work, the kids, or just 'getting older.' What if it's not any of those things? Dr. Maichou Yang helps EDH residents breathe better and wake up actually feeling rested.",
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 23, 2025',
    readTime: '11 min read',
    category: 'Sleep Apnea El Dorado Hills',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-rocklin-ca',
    title: 'Sleep Apnea Dentist in Rocklin, CA: Your Neighbor for Better Sleep',
    excerpt: "Rocklin residents — did you know there's a sleep apnea specialist just 5 minutes away? Dr. Maichou Yang at Sunshine Dental Care offers custom oral appliances that let you ditch the CPAP and finally get the restful sleep you deserve.",
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 22, 2025',
    readTime: '10 min read',
    category: 'Sleep Apnea Rocklin',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-oral-device-roseville-ca',
    title: 'Sleep Apnea Oral Device in Roseville, CA: A Life-Changing Alternative to CPAP',
    excerpt: "Tired of your CPAP gathering dust? You're not alone. Discover how a custom sleep apnea oral device from Dr. Maichou Yang at Sunshine Dental Care is helping Roseville residents finally get the restful sleep they deserve — without the mask, hose, or noise.",
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 22, 2025',
    readTime: '11 min read',
    category: 'Sleep Apnea Oral Device',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-loomis-ca',
    title: 'Sleep Apnea Dentist Near Me in Loomis, CA: Expert Care at Sunshine Dental Care',
    excerpt: 'Loomis, CA residents searching for a sleep apnea dentist near me can find specialized airway treatment at Sunshine Dental Care in Roseville — just minutes down I-80. Dr. Maichou Yang offers custom oral appliances for the Loomis community.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 21, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Loomis',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-elk-grove-ca',
    title: 'Sleep Apnea Dentist Near Me in Elk Grove, CA: Quality Sleep Health Care',
    excerpt: 'Elk Grove residents looking for a sleep apnea dentist near me trust Sunshine Dental Care. Dr. Maichou Yang provides expert oral appliance therapy for the Elk Grove community — conveniently accessible via Highway 99 and I-5.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 21, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Elk Grove',
    image: 'https://images.unsplash.com/photo-1509453721491-c3af5961df76?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-west-sacramento-ca',
    title: 'Sleep Apnea Dentist Near Me in West Sacramento, CA: Your Path to Better Sleep',
    excerpt: 'West Sacramento patients searching for a sleep apnea dentist near me choose Sunshine Dental Care in Roseville. Dr. Maichou Yang offers custom oral appliances and expert airway treatment — an easy drive via I-80 or Business 80.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 21, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea West Sacramento',
    image: 'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'stop-snoring-roseville-ca',
    title: 'How to Stop Snoring in Roseville, CA: Proven Dental Solutions at Sunshine Dental Care',
    excerpt: 'Ready to stop snoring in Roseville, CA? Dr. Maichou Yang at Sunshine Dental Care offers custom oral appliances that eliminate snoring and restore peaceful sleep for you and your partner.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'January 8, 2026',
    readTime: '10 min read',
    category: 'Snoring Treatment',
    image: 'https://images.unsplash.com/photo-1758524945995-e5f12a1a8f45?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-lincoln-ca',
    title: 'Sleep Apnea Dentist Near Me in Lincoln, CA: Trusted Care at Sunshine Dental Care',
    excerpt: 'Lincoln, CA residents searching for a sleep apnea dentist near me can find expert oral appliance therapy at Sunshine Dental Care in nearby Roseville — just a quick drive south on Highway 65.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 20, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Lincoln',
    image: 'https://images.pexels.com/photos/6787542/pexels-photo-6787542.jpeg?auto=compress&cs=tinysrgb&w=800',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-granite-bay-ca',
    title: 'Sleep Apnea Dentist Near Me in Granite Bay, CA: Premium Care Minutes Away',
    excerpt: 'Granite Bay residents deserve premium sleep apnea care. Dr. Maichou Yang at Sunshine Dental Care offers expert oral appliance therapy just minutes from Granite Bay via Douglas Blvd.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 20, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Granite Bay',
    image: 'https://images.pexels.com/photos/7556587/pexels-photo-7556587.jpeg?auto=compress&cs=tinysrgb&w=800',
    featured: false
  },
  {
    id: 'sleep-apnea-dentist-auburn-ca',
    title: 'Sleep Apnea Dentist Near Me in Auburn, CA: Sierra Foothills Sleep Health',
    excerpt: 'Auburn, CA patients searching for a sleep apnea dentist near me trust Sunshine Dental Care in Roseville. Dr. Maichou Yang provides custom oral appliance therapy — an easy drive down I-80.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 20, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Auburn',
    image: 'https://images.pexels.com/photos/28221297/pexels-photo-28221297.jpeg?auto=compress&cs=tinysrgb&w=800',
    featured: false
  },
  {
    id: 'sleep-apnea-dentist-folsom-ca',
    title: 'Sleep Apnea Dentist in Folsom, CA: Because You Deserve to Actually Feel Rested',
    excerpt: "Folsom, can we have an honest conversation? When was the last time you woke up and actually felt good? If you can't remember, Dr. Maichou Yang can help — with custom oral appliances that let you ditch the CPAP.",
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 22, 2025',
    readTime: '11 min read',
    category: 'Sleep Apnea Folsom',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-sacramento-ca',
    title: 'Sleep Apnea Dentist Near Me in Sacramento, CA: Expert Treatment at Sunshine Dental Care',
    excerpt: 'Sacramento residents searching for a sleep apnea dentist near me can access specialized airway treatment at Sunshine Dental Care in Roseville — conveniently located off I-80.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 20, 2025',
    readTime: '10 min read',
    category: 'Sleep Apnea Sacramento',
    image: 'https://images.unsplash.com/photo-1656716705147-7ab83f50e956?w=800&auto=format&fit=crop&q=60',
    featured: false
  },
  {
    id: 'sleep-apnea-dentist-rancho-cordova-ca',
    title: 'Sleep Apnea Dentist in Rancho Cordova, CA: Stop Surviving and Start Living',
    excerpt: "Rancho Cordova, when did 'tired' become your default setting? If you're running on empty despite sleeping all night, it might be sleep apnea — and Dr. Maichou Yang has helped hundreds of people just like you get their energy back.",
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 23, 2025',
    readTime: '11 min read',
    category: 'Sleep Apnea Rancho Cordova',
    image: 'https://images.unsplash.com/photo-1713947505775-4e3af92a4ee7?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'sleep-apnea-dentist-citrus-heights-ca',
    title: 'Sleep Apnea Dentist Near Me in Citrus Heights, CA: Breathe Better, Sleep Better',
    excerpt: 'Citrus Heights residents searching for a sleep apnea dentist near me can find expert care at Sunshine Dental Care in nearby Roseville. Dr. Maichou Yang provides custom oral appliance therapy just minutes from Citrus Heights via I-80.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 15, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Citrus Heights',
    image: 'https://images.pexels.com/photos/36813257/pexels-photo-36813257.jpeg?auto=compress&cs=tinysrgb&w=800',
    featured: true
  },

  {
    id: 'sleep-apnea-dentist-fair-oaks-ca',
    title: 'Sleep Apnea Dentist Near Me in Fair Oaks, CA: Expert Care Close to Home',
    excerpt: 'Fair Oaks residents looking for a sleep apnea dentist near me can find specialized airway treatment at Sunshine Dental Care. Dr. Maichou Yang is just a short drive from Fair Oaks via Sunrise Blvd. Call (916) 773-1122.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 15, 2025',
    readTime: '9 min read',
    category: 'Sleep Apnea Fair Oaks',
    image: 'https://images.unsplash.com/photo-1552650272-b8a34e21bc4b?w=800&auto=format&fit=crop&q=60',
    featured: false
  },
  {
    id: 'sleep-apnea-dentist-orangevale-ca',
    title: 'Sleep Apnea Dentist Near Me in Orangevale, CA: Expert Treatment at Sunshine Dental Care',
    excerpt: 'Searching for a sleep apnea dentist near me in Orangevale, CA? Dr. Maichou Yang at Sunshine Dental Care in nearby Roseville offers custom oral appliance therapy, nightguards, and expert airway treatment — just minutes from Orangevale.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'December 5, 2025',
    readTime: '10 min read',
    category: 'Sleep Apnea Orangevale',
    image: 'https://images.unsplash.com/photo-1531353826977-0941b4779a1c?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'dental-sleep-medicine-roseville-ca',
    title: 'Dental Sleep Medicine in Roseville, CA: How Your Dentist Can Treat Sleep Apnea & Snoring',
    excerpt: 'Learn how dental sleep medicine in Roseville, CA is transforming the way patients treat sleep apnea and chronic snoring. Dr. Maichou Yang at Sunshine Dental Care provides expert oral appliance therapy backed by the latest clinical research.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'September 22, 2025',
    readTime: '11 min read',
    category: 'Dental Sleep Medicine',
    image: 'https://images.unsplash.com/photo-1615388247210-f97018b08786?w=800&auto=format&fit=crop&q=60',
    featured: true
  },
  {
    id: 'best-sleep-apnea-dentist-roseville-ca',
    title: 'Best Sleep Apnea Dentist in Roseville, CA: Why Patients Choose Sunshine Dental Care',
    excerpt: 'Discover why Sunshine Dental Care is rated the best sleep apnea dentist in Roseville, CA. Dr. Maichou Yang offers advanced oral appliance therapy, custom nightguards, and personalized airway treatment plans that help patients breathe better and sleep soundly.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'June 10, 2025',
    readTime: '10 min read',
    category: 'Sleep Apnea Treatment',
    image: 'https://images.unsplash.com/photo-1758273239813-cecda76c6c19?w=800&auto=format&fit=crop&q=60',
    featured: false
  },
  {
    id: 'sleep-apnea-dentist-roseville-ca',
    title: 'Finding the Best Sleep Apnea Dentist Near Me in Roseville, CA: Your Complete Guide',
    excerpt: 'Looking for a sleep apnea dentist near me in Roseville, CA? Learn how Dr. Maichou Yang at Sunshine Dental Care provides custom nightguards and oral appliance therapy for effective sleep apnea treatment.',
    author: 'Dr. Maichou Yang, DDS',
    date: 'March 15, 2025',
    readTime: '8 min read',
    category: 'Sleep Apnea',
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&auto=format&fit=crop&q=60',
    featured: false
  }
];

const BlogSection = () => {
  return (
    <section id="blog" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-cyan-600 font-semibold tracking-wider uppercase text-sm">
            Dental Health Insights
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
            Our Blog
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Expert advice on sleep apnea treatment, dental health, and achieving your best smile from Dr. Maichou Yang and the Sunshine Dental Care team.
          </p>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow duration-300"
              data-testid={`blog-card-${post.id}`}
            >
              <Link to={`/blog/${post.id}`}>
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                  {post.featured && (
                    <span className="absolute top-4 left-4 bg-cyan-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      Featured
                    </span>
                  )}
                  <span className="absolute top-4 right-4 bg-white/90 text-gray-700 text-xs font-medium px-3 py-1 rounded-full">
                    {post.category}
                  </span>
                </div>
              </Link>
              
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <Calendar size={14} />
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock size={14} />
                    {post.readTime}
                  </span>
                </div>
                
                <Link to={`/blog/${post.id}`}>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-cyan-600 transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                </Link>
                
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-sm text-gray-500">
                    <User size={14} />
                    {post.author}
                  </span>
                  <Link 
                    to={`/blog/${post.id}`}
                    className="flex items-center gap-1 text-cyan-600 font-semibold hover:text-cyan-700 transition-colors"
                  >
                    Read More <ArrowRight size={16} />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Quiz CTA Banner */}
        <div className="mt-12 p-8 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl text-white" data-testid="blog-quiz-cta">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-xl font-bold mb-2">Think You Might Have Sleep Apnea?</h3>
              <p className="text-gray-300 text-sm">Take our free 2-minute risk assessment quiz. Answer 10 simple questions and get your results instantly.</p>
            </div>
            <Link
              to="/sleep-apnea-quiz"
              className="inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 text-white font-semibold px-6 py-3 rounded-lg transition-colors whitespace-nowrap"
              data-testid="blog-quiz-cta-button"
            >
              Take the Quiz <ArrowRight size={18} />
            </Link>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 mb-4">
            Have questions about sleep apnea or dental health? We're here to help!
          </p>
          <a
            href="tel:9167731122"
            className="inline-flex items-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Schedule a Consultation: (916) 773-1122
          </a>
        </div>
      </div>
    </section>
  );
};

export { blogPosts };
export default BlogSection;
